import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@design-system/box';
import { Dotdotdot } from '@design-system/dotdotdot';
import { Image } from '@design-system/image';
import { Link } from '@design-system/link';
import { styled } from 'styled-components';
export const NewsPresentation = ({ date, image, isLast, name, path, }) => (_jsxs(Box, { flexDirection: { _: 'column', m: 'row' }, width: "100%", children: [_jsx(ImageWrapper, { "$isLast": isLast, children: _jsx(Link, { styledOnlyOnHover: true, tabIndex: -1, to: path, width: "100%", children: _jsx(Image, { alt: `Image for news ${name}`, height: "100%", src: image, style: { objectFit: 'cover' }, width: "100%" }) }) }), _jsxs(Box, { flexDirection: "column", justifyContent: "center", maxWidth: { _: '100%', m: '60%' }, mb: isLast ? 0 : { _: 5, m: 6 }, children: [_jsx(Box, { mb: 1, children: _jsx(Link, { font: "h4-semibold", styledOnlyOnHover: true, to: path, width: "100%", children: _jsx(Dotdotdot, { clamp: 2, children: name }) }) }), _jsx(Box, { children: date })] })] }));
const ImageWrapper = styled(Box).attrs(({ $isLast }) => ({
    height: { _: '119px', m: '69px' },
    maxWidth: { _: '221px', m: '186px' },
    mb: { _: 3, m: $isLast ? 0 : 6 },
    minHeight: { _: '119px', m: '69px' },
    mr: { _: 0, m: 6 },
    width: { _: '65%', m: '40%' },
})) `
  border-radius: ${({ theme }) => `${theme.themeVariables.globalBorderRadius}px`};
  overflow: hidden;
`;
//# sourceMappingURL=NewsPresentation.js.map